export const trackPageView = (): void => {
  if (!ym) return;
  ym(72867682, 'hit', window.location.pathname);
};
